import React, { useState, useEffect } from "react";
import { Table, Button, Form, Modal } from "react-bootstrap";
import { FaChevronLeft } from "react-icons/fa";
import Api from "../../utils/Api";
import { useMediaQuery } from "react-responsive";
import Notifier from "../../components/Notifier";

export default function Accounts() {
    const [accounts, setAccounts] = useState([]);
    const [changeCredentials, setChangeCredentials] = useState(false);
    const [credentialsTypes, setCredentialsTypes] = useState();
    const [currentTask, setCurrentTask] = useState({ details: "" });
    const [credentials, setCredentials] = useState([]);
    const [selectedAccount, setSelectedAccount] = useState();
    const isMobile = useMediaQuery({ query: "(max-width: 599px)" });
    const notifierRef = React.createRef();
    const changedCredentials = {};

    useEffect(() => {
        refreshData();
    }, []);

    const refreshData = async () => {
        const { response: { accounts, credentialsTypes: credentialsTypesLookup } } = await Api.accounts();
        notifierRef?.current?.showSuccess("הרשימה עודכנה");
        setAccounts(accounts);
        setCredentialsTypes(credentialsTypesLookup);
    }

    const handleChangeCredentials = (run) => {
        setSelectedAccount(undefined);
        setCredentials(credentialsTypes[run.type]);
        setCurrentTask(run);
        setChangeCredentials(true);
    };

    const closeChangeCredentials = () => {
        setChangeCredentials(false);
    };

    const toggleAccountStatus = async (taskId, enabled) => {
        try {
            const response = await Api.updateAccountStatus({
                taskId,
                enabled
            });
            if (response.status === 200) {
                notifierRef?.current?.showSuccess("עודכן בהצלחה");
                refreshData();
            } else {
                notifierRef?.current?.showError("שגיאה בעדכון");
            }
            refreshData();
        } catch (error) {
            console.log(`Error updating credentials`, error);
            notifierRef?.current?.showError("שגיאה בעדכון");
        }
    }

    const handleCredentialsValueChange = (type, value) => {
        changedCredentials[currentTask.id] = { ...changedCredentials[currentTask.id], [type]: value };
    };

    const saveChangeCredentials = async () => {
        try {
            const response = await Api.updateCredentials({
                taskId: currentTask.id,
                credentials: changedCredentials[currentTask.id],
                customerId: currentTask.customerId
            });
            if (response.status === 200) {
                notifierRef?.current?.showSuccess("עודכן בהצלחה");
                refreshData();
            } else {
                notifierRef?.current?.showError("שגיאה בעדכון");
            }
            closeChangeCredentials();
        } catch (error) {
            console.log(`Error updating credentials`, error);
            notifierRef?.current?.showError("שגיאה בעדכון");
        }
    };

    const cardStyle = {
        background: "white",
        boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
        borderRadius: "10px",
        width: isMobile ? "95%" : "50%",
        margin: "auto"
    };

    return <div>
        <div style={{
            width: "50%",
            margin: "auto",
            direction: "rtl",
            marginBottom: "10px"
        }}>
            <Button style={{ marginRight: "10px" }} onClick={() => refreshData()}>רענן</Button>
        </div>
        <div style={cardStyle}>
            <Table hover style={{ width: isMobile ? "100%" : "90%", margin: "auto" }}>
                <thead>
                    <tr>
                        <th>Description</th>
                        <th>Type</th>
                        <th>Active</th>
                        <th style={{ width: "30px" }}></th>
                    </tr>
                </thead>
                <tbody>
                    {accounts.map((account, index) => {
                        return (
                            <tr key={index} onClick={() => setSelectedAccount(account)} style={{ cursor: "pointer" }}>
                                <td style={{ verticalAlign: "middle" }}>{account.description}</td>
                                <td style={{ verticalAlign: "middle" }}>{account.type}</td>
                                <td style={{ verticalAlign: "middle" }} onClick={(e) => e.stopPropagation()}>
                                    <Form.Check
                                        type="switch"
                                        id={`account-active-${account.id}`}
                                        checked={!!account.enabled}
                                        onChange={() => toggleAccountStatus(account.id, !account.enabled)}
                                    />
                                </td>
                                <td style={{ verticalAlign: "middle", color: "#6c757d" }}>
                                    <FaChevronLeft />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>

            <Modal show={!!selectedAccount} onHide={() => setSelectedAccount(undefined)}>
                <Modal.Header closeButton style={{ direction: "rtl", gap: "16px" }}>
                    <Modal.Title>{selectedAccount?.description}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {[
                        ["CustomerId", selectedAccount?.customerId],
                        ["Type", selectedAccount?.type],
                        ["Account Number", selectedAccount?.accountNumber],
                        ["Days back", selectedAccount?.daysBack]
                    ].map(([label, value]) => (
                        <p key={label} dir="ltr" style={{ textAlign: "right" }}>{label}: {value || "-"}</p>
                    ))}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setSelectedAccount(undefined)}>Close</Button>
                    <Button onClick={() => handleChangeCredentials(selectedAccount)}>Change Credentials</Button>
                </Modal.Footer>
            </Modal>

            <Modal show={changeCredentials} onHide={closeChangeCredentials}>
                <Modal.Header closeButton>
                    <Modal.Title>Change Cretentials</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        credentials.map(item =>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
                                <p>{item}</p>
                                <input
                                    onChange={(e) => handleCredentialsValueChange(item, e.target.value)}
                                    style={{ width: "70%" }}
                                />
                            </div>)
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={saveChangeCredentials}>Save</Button>
                </Modal.Footer>
            </Modal>
            <Notifier ref={notifierRef} />
        </div>
    </div>
}
